export const BASE_CLASS = 'mt-VehicleSuggester'
export const STEPS = {
  PRICE_RANGE: 1,
  BODY_TYPES: 2,
  FUEL_TYPES: 3,
  SEATS: 4,
  MAKES: 5
}
export const TOTAL_STEPS = Object.keys(STEPS).length

export const NOT_FOUND_IMAGE_PATH = 'illustrations/coches-error-404.svg'
export const INTERNAL_SERVER_ERROR_IMAGE_PATH = 'illustrations/coches-error-500.svg'
export const collapsibleMinHeight = 184
export const KEYBOARD_EVENTS = {
  ENTER: 'Enter',
  BACKSPACE: 'Backspace',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_LEFT: 'ArrowLeft'
}

export const PRICE_MODE = {
  INSTALLMENT: 'installment',
  FULL_PRICE: 'full_price'
}

export const defaultTopbarProps = {
  customContent: <></>,
  mainNavigationItems: [],
  showBrandIcon: true,
  showNavUserOnDesktop: false,
  showToggleNavOnMobile: false
}
